import { useLocation, useParams } from "react-router-dom";

const UserCollectioncovercontent = () => {
  const { state } = useLocation();
  const { content } = state || {};

  if (!content) return <div>No content available</div>;

  return (
    <div className="relative w-full h-screen bg-gray-100 p-4">
      <div className="w-full h-full overflow-auto border rounded shadow bg-white">
        <iframe
          title="Comic Content"
          srcDoc={content}
          className="w-full h-full border-none"
          sandbox=""
        />
      </div>
    </div>
  );
};
export default UserCollectioncovercontent;
